import {autoserializeAs} from 'cerialize';
import {RLCountModel} from './rl-count.model';

export class RLCountsModel {
    @autoserializeAs(RLCountModel) public steps: RLCountModel[];
    @autoserializeAs(RLCountModel) public transitions: RLCountModel[];
}
